import api from '@api';
import { withArchive } from 'src/resources/withArchive';
import { call, put, select, takeEvery } from 'redux-saga/effects';
import { getClaimsGridFetchSuccess, getClaimsGridFetchFailure } from './reducer';
import { ClaimsGridResType } from 'src/types/claimsGrid';
import { GridRequestType } from 'src/types/table';
import { RootStoreType } from 'src/types/store';

export const CLAIM_GRID_URL = 'api/secure/claims/grid';
export const CLAIM_GRID_ALL_PROVIDERS_URL = 'api/secure/claims/grid-all-providers';
export const CLAIM_GRID_PRODUCTS_URL = 'api/secure/claims/claimsProducts';
export interface GetClaimGridCallPayloadType {
    params: GridRequestType;
    allProviders: boolean;
    archive?: boolean;
}

const getClaimsGridFetchRequest = async (payload: GetClaimGridCallPayloadType) => {
    const res = await api(
        'post',
        withArchive(payload.allProviders ? CLAIM_GRID_ALL_PROVIDERS_URL : CLAIM_GRID_URL, payload.archive),
        payload.params
    );
    return res.data.data;
};

function* getClaimsGridFetch(action: { type: string; payload?: GetClaimGridCallPayloadType }) {
    try {
        let payloadData: GetClaimGridCallPayloadType | undefined = action.payload;
        if (!payloadData) {
            const params: GridRequestType = yield select((state: RootStoreType) => state.claimsGrid.data?.request);
            const allProviders: boolean = yield select((state: RootStoreType) => state.claimsGrid.allProviders);
            const archive: boolean = yield select((state: RootStoreType) => !!state.claimsGrid.archive);
            if (params) {
                payloadData = {
                    params,
                    allProviders,
                    archive,
                };
            }
        }
        if (payloadData) {
            // @ts-ignore
            const response: ClaimsGridResType = yield call((): any => getClaimsGridFetchRequest(payloadData));
            yield put(getClaimsGridFetchSuccess(response));
        } else {
            yield put(getClaimsGridFetchFailure({ error: null }));
        }
    } catch (error) {
        yield put(getClaimsGridFetchFailure({ error }));
    }
}

export function* getClaimsGridFetchWatch() {
    yield takeEvery('claimsGrid/getClaimsGridFetch', getClaimsGridFetch);
}
